import React from 'react';
import styled from 'styled-components';
import { Absolute, BackgroundImage, Flex, Relative, Hide } from 'pcln-design-system';
const AbsoluteOverflow = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "ImageContainer__AbsoluteOverflow",
  componentId: "sc-qn5i3e-0"
})(["overflow:hidden;"]);
const CropFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "ImageContainer__CropFlex",
  componentId: "sc-qn5i3e-1"
})(["overflow:hidden;"]);
const OnTopBackgroundImage = /*#__PURE__*/styled(BackgroundImage).withConfig({
  displayName: "ImageContainer__OnTopBackgroundImage",
  componentId: "sc-qn5i3e-2"
})(["z-index:5;"]);
const CroppedImage = ({
  imageMirrorProps,
  imageUrl,
  imageClassName
}) => React.createElement(CropFlex, {
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  borderRadius: 'full',
  ...imageMirrorProps
}, React.createElement(OnTopBackgroundImage, {
  width: '100%',
  height: '100%',
  image: imageUrl,
  className: imageClassName
}));
/** @public */
const ImageContainer = ({
  mirror = 'right',
  imageUrl,
  imageClassName
}) => {
  const imageHeights = ['212px', null, null, '240px', '420px'];
  const HORIZONTAL_OFFSET = '-20%';
  const absoluteMirrorProps = mirror === 'left' ? {
    left: HORIZONTAL_OFFSET
  } : {
    right: HORIZONTAL_OFFSET
  };
  const imageMirrorProps = mirror === 'left' ? {
    rounded: 'right'
  } : {
    rounded: 'left'
  };
  return React.createElement(React.Fragment, null, React.createElement(Hide, {
    xl: true,
    xxl: true
  }, React.createElement(Relative, {
    width: '72%',
    height: imageHeights,
    left: ['14%', null, null, null, '28%'],
    top: '16px'
  }, React.createElement(CroppedImage, {
    imageUrl: imageUrl,
    imageMirrorProps: imageMirrorProps,
    imageClassName: imageClassName
  }))), React.createElement(Hide, {
    xs: true,
    sm: true,
    md: true,
    lg: true
  }, React.createElement(AbsoluteOverflow, {
    width: '97%',
    height: imageHeights,
    top: '8%',
    ...absoluteMirrorProps
  }, React.createElement(CroppedImage, {
    imageUrl: imageUrl,
    imageMirrorProps: imageMirrorProps,
    imageClassName: imageClassName
  }))));
};
export { ImageContainer };